"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApproveDropShipInfo = void 0;
const common_1 = require("../../common");
class ApproveDropShipInfo extends common_1.UpdateAction {
}
exports.ApproveDropShipInfo = ApproveDropShipInfo;
//# sourceMappingURL=approve-drop-ship-info.action.js.map